import { render, staticRenderFns } from "./plmBomCompare.vue?vue&type=template&id=285d79c0&scoped=true"
import script from "./plmBomCompare.vue?vue&type=script&lang=js"
export * from "./plmBomCompare.vue?vue&type=script&lang=js"
import style0 from "./plmBomCompare.vue?vue&type=style&index=0&id=285d79c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285d79c0",
  null
  
)

export default component.exports